Vue.component("category-list-component", require("./Index.vue").default);
Vue.component("category-create-component", require("./Create.vue").default);
Vue.component("category-edit-component", require("./Edit.vue").default);
Vue.component("category-delete-component", require("./Delete.vue").default);